<template>
    <div id="supplier-onboarding-bank-account" class="vx-col sm:w-5/6 md:w-2/3 lg:w-2/3 xl:w-3/5 xxl:w-2/3 m-0">
        <div class="vx-row no-gutter items-center justify-center p-6">
            <vx-card class="login-card py-3 px-3">
               <SupplierBusinessCLABE 
                :onboardingStepData="onboardingStepData" 
                :isPersonal="!isMoral" 
                @updated="onUpdated"/>
            </vx-card>
        </div>
    </div>
</template>

<script>
import SupplierBusinessCLABE from "@/views/supplier/profile/SupplierBusinessCLABE";
export default {
    name: 'SupplierOnboardingBankAccount',
    props: ['onboardingStepData', 'isMoral'],
    components: {
        SupplierBusinessCLABE
    },
    data() {
        return {};
    },
    methods: {
        onUpdated(bankAccount) {
            this.checkIfCanUpdateSupplierOnboardingStep("bank_account");
            this.$emit("updated", bankAccount);
        }
    },
};
</script>